import { useEffect, useState } from 'react'
import { httpOk, GET } from 'helpers/api'
import { accountStorageKey } from './useAnalyticsFilters'

// Справочники панели фильтров (филиалы, источники, меню, склады, поставщики…).
// Кэш на время жизни вкладки: переход между отчётами не перезапрашивает одно и то же.
// Кэш привязан к логину: после выхода и входа в другой логин без перезагрузки страницы
// в списке оставались филиалы предыдущего аккаунта.
const cache = new Map()
let posesPromise = null
let cacheOwner = null

function resetCacheOnAccountChange() {
	const owner = accountStorageKey()
	if (owner === cacheOwner) return
	cacheOwner = owner
	cache.clear()
	posesPromise = null
}

function loadPoses() {
	resetCacheOnAccountChange()
	if (!posesPromise) {
		posesPromise = GET('/helper/poses').then(response => {
			if (httpOk(response)) return response.data || []
			posesPromise = null
			return []
		})
	}
	return posesPromise
}

function loadOptions(include, posId) {
	resetCacheOnAccountChange()
	const key = `${posId}|${include.join(',')}`
	if (!cache.has(key)) {
		const promise = GET(`/analytics/filter-options?pos_id=${posId ?? -1}&include=${include.join(',')}`).then(response => {
			if (httpOk(response)) return response.data || {}
			cache.delete(key)
			return {}
		})
		cache.set(key, promise)
	}
	return cache.get(key)
}

/**
 * include — какие справочники нужны экрану: sources, menus, categories, warehouses,
 * suppliers, expense_purposes, payment_types, couriers. Филиалы и типы заказа есть всегда.
 * posId — филиал черновика фильтра: склады, поставщики и курьеры зависят от него.
 */
function useAnalyticsOptions(include = [], posId = -1) {
	const [poses, setPoses] = useState([])
	const [options, setOptions] = useState({})
	const includeKey = include.join(',')

	useEffect(() => {
		let alive = true
		loadPoses().then(data => alive && setPoses(data))
		return () => { alive = false }
	}, [])

	useEffect(() => {
		let alive = true
		loadOptions(include, posId).then(data => alive && setOptions(data))
		return () => { alive = false }
	}, [includeKey, posId]) // eslint-disable-line react-hooks/exhaustive-deps

	return {
		poses,
		orderTypes: options.order_types || [],
		sources: options.sources || [],
		menus: options.menus || [],
		categories: options.categories || [],
		warehouses: options.warehouses || [],
		suppliers: options.suppliers || [],
		expensePurposes: options.expense_purposes || [],
		paymentTypes: options.payment_types || [],
		couriers: options.couriers || [],
	}
}

export default useAnalyticsOptions
